import { HostBinding, Component, OnInit } from '@angular/core';
import { routerTransition } from 'app/shared/animations/router-transition.animation';
import { VestibularService } from '../shared/vestibular.service';
import { environment } from './../../../environments/environment';
import { Router } from '@angular/router';

@Component({
  selector: 'app-calendario',
  templateUrl: './calendario.component.html',
  styleUrls: ['./calendario.component.scss'],
  animations: [routerTransition],
})
export class CalendarioComponent implements OnInit {
  @HostBinding('@routerTransition') routerTransition = true;
  @HostBinding('style.display') display = 'block';

  environment = environment;
  calendarios;
  calendarioCarregando = true;

  constructor(
    private vestibularServico: VestibularService,
    private router: Router
  ) { }

  ngOnInit() {
    if(environment.loginContexto!=='CEUMA'){
      return this.router.navigate(['/vestibular/ceuma']);
    }

    this.vestibularServico.calendario().then((calendario) => {
      this.calendarios = calendario;
      this.calendarioCarregando = false;
    });
  }
}
